import React from 'react'
import styles from './ThinkingAnimation.module.css'

interface ThinkingAnimationProps {
  text?: string
}

export const ThinkingAnimation: React.FC<ThinkingAnimationProps> = ({ text = 'Thinking...' }) => {
  return (
    <div className={styles.container}>
      <div className={styles.shimmerWrapper}>
        <span className={styles.shimmerText}>{text}</span>
      </div>
    </div>
  )
}

export default ThinkingAnimation
